import { OperatorsType } from './types';

/** Чувствительные к регистру операторы */
export enum SENSITIVE_VALUES {
  'exact' = 'exact',
  'exact!' = 'exact!',
  'contains' = 'contains',
  'contains!' = 'contains!',
  'like' = 'like',
  'like!' = 'like!',
  'gt' = 'gt',
  'gte' = 'gte',
  'lt' = 'lt',
  'lte' = 'lte',
  'regex' = 'regex',
  'regex!' = 'regex!',
  // TODO: Это было ранее закомментировано. Необходимо выяснить для каких целей это тут появилось и почему убралось
  // 'in' = 'in',
  // 'in!' = 'in!',
  'range' = 'range',
  'range!' = 'range!',
  // 'isnull' = 'isnull',
  // 'isnull!' = 'isnull!',
}

export enum NullFilterOperation {
  'is_null' = 'isnull',
}

export enum ListFilterParams {
  in = `in`,
}

/** Нечувствительные к регистру операторы */
export enum INSENSITIVE_VALUES {
  'iexact' = 'iexact',
  'iexact!' = 'iexact!',
  'icontains' = 'icontains',
  'icontains!' = 'icontains!',
  'ilike' = 'ilike',
  'ilike!' = 'ilike!',
  // 'irange' = 'irange',
  // 'irange!' = 'irange!',
}

export type Operator =
  | SENSITIVE_VALUES
  | INSENSITIVE_VALUES
  | NullFilterOperation
  | ListFilterParams;

export type OperatorDescription = Record<Operator, string>;

export const OPERATOR_DESCRIPTION: OperatorDescription = {
  in: 'В списке значений',
  // 'in!':'Не в списке значений',
  // 'irange!': 'Вне диапазоне',
  'range!': 'Вне диапазона',
  range: 'В диапазоне',
  // irange: 'В диапазоне',
  isnull: '=NULL',
  exact: '=',
  'exact!': '≠',
  iexact: '=',
  'iexact!': '≠',
  icontains: 'Содержит',
  'icontains!': 'Не содержит',
  contains: 'Содержит',
  'contains!': 'Не содержит',
  gt: '>',
  gte: '≥',
  lt: '<',
  lte: '≤',
  like: 'Соответствует шаблону',
  'like!': 'Не соответствует шаблону',
  ilike: 'Соответствует шаблону',
  'ilike!': 'Не соответствует шаблону',
  regex: 'Соответствует регулярному выражению',
  'regex!': 'Не соответствует регулярному выражению',
};

export const OPERATOR_VALUES: Record<Operator, Operator | undefined> = {
  in: ListFilterParams.in,
  // | 'in!'
  range: SENSITIVE_VALUES.range,
  'range!': SENSITIVE_VALUES['range!'],
  // 'range!': INSENSITIVE_VALUES['irange!'],
  // irange: SENSITIVE_VALUES.range,
  // 'irange!': SENSITIVE_VALUES['range!'],
  [NullFilterOperation.is_null]: NullFilterOperation.is_null,
  exact: INSENSITIVE_VALUES.iexact,
  'exact!': INSENSITIVE_VALUES['iexact!'],
  iexact: SENSITIVE_VALUES.exact,
  'iexact!': SENSITIVE_VALUES['exact!'],
  contains: INSENSITIVE_VALUES.icontains,
  'contains!': INSENSITIVE_VALUES['icontains!'],
  icontains: SENSITIVE_VALUES.contains,
  'icontains!': SENSITIVE_VALUES['contains!'],
  gt: undefined,
  gte: undefined,
  lt: undefined,
  lte: undefined,
  like: INSENSITIVE_VALUES.ilike,
  'like!': INSENSITIVE_VALUES['ilike!'],
  ilike: SENSITIVE_VALUES.like,
  'ilike!': SENSITIVE_VALUES['like!'],
  regex: undefined,
  'regex!': undefined,
};

export const OPERATORS_TYPE: OperatorsType = {
  string: {
    initial: [
      INSENSITIVE_VALUES.iexact,
      INSENSITIVE_VALUES['iexact!'],
      INSENSITIVE_VALUES.icontains,
      INSENSITIVE_VALUES['icontains!'],
      INSENSITIVE_VALUES.ilike,
      INSENSITIVE_VALUES['ilike!'],
      SENSITIVE_VALUES.regex,
      SENSITIVE_VALUES['regex!'],
    ],
    opposite: [
      SENSITIVE_VALUES.exact,
      SENSITIVE_VALUES['exact!'],
      SENSITIVE_VALUES.contains,
      SENSITIVE_VALUES['contains!'],
      SENSITIVE_VALUES.like,
      SENSITIVE_VALUES['like!'],
    ],
  },
  number: {
    initial: [
      SENSITIVE_VALUES.exact,
      SENSITIVE_VALUES['exact!'],
      SENSITIVE_VALUES.gt,
      SENSITIVE_VALUES.gte,
      SENSITIVE_VALUES.lt,
      SENSITIVE_VALUES.lte,
    ],
    opposite: [],
  },
  date: {
    initial: [
      SENSITIVE_VALUES.exact,
      SENSITIVE_VALUES['exact!'],
      SENSITIVE_VALUES.gt,
      SENSITIVE_VALUES.gte,
      SENSITIVE_VALUES.lt,
      SENSITIVE_VALUES.lte,
      SENSITIVE_VALUES.range,
      SENSITIVE_VALUES['range!'],
    ],
    opposite: [],
  },
  time: {
    initial: [
      SENSITIVE_VALUES.exact,
      SENSITIVE_VALUES['exact!'],
      SENSITIVE_VALUES.gt,
      SENSITIVE_VALUES.gte,
      SENSITIVE_VALUES.lt,
      SENSITIVE_VALUES.lte,
      SENSITIVE_VALUES.range,
      SENSITIVE_VALUES['range!'],
    ],
    opposite: [],
  },
  datetime: {
    initial: [
      SENSITIVE_VALUES.exact,
      SENSITIVE_VALUES['exact!'],
      SENSITIVE_VALUES.gt,
      SENSITIVE_VALUES.gte,
      SENSITIVE_VALUES.lt,
      SENSITIVE_VALUES.lte,
      SENSITIVE_VALUES.range,
      SENSITIVE_VALUES['range!'],
    ],
    opposite: [],
  },
  boolean: {
    initial: [SENSITIVE_VALUES.exact, SENSITIVE_VALUES['exact!']],
    opposite: [],
  },
  other: {
    initial: [],
    opposite: [],
  },
  'table-record-reference': {
    initial: [SENSITIVE_VALUES.exact, SENSITIVE_VALUES['exact!']],
    opposite: [],
  },
};

export enum OperatorType {
  INITIAL = 'initial',
  OPPOSITE = 'opposite',
}
